import { NgApiClient } from '@src/api/ngApiClient';

export class SSEConfig {
  constructor(private client: NgApiClient) {}

  public getSSEUrl(): string {
    return `${this.client.configUrls.xapilb}/api-notifications/events`;
  }

  public getHeaders(): Record<string, string> {
    const headers: Record<string, string> = {};
    const accessToken = this.client.getAccessToken();
    if (accessToken) {
      headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return headers;
  }
}
